import { RouteObject } from 'react-router';
import { HomePageView } from '../views/home-page/home-page.tsx';
import {
  ScheduleMeetingView,
} from '../views/schedule-meeting-page/schedule-meeting-page.tsx';
import { SearchPage } from '../unstructured-pages/SearchPage/search-page.tsx';
import { DetailsPage } from '../unstructured-pages/DetailsPage/DetailsPage.tsx';
import { ModelsCatalog } from '../unstructured-pages/ModelsCatalog/ModelsCatalog.tsx';
import { ModelsDetailsView } from '../views/models-details/models-details.tsx';
import { PanoramaViewerPage } from '../unstructured-pages/PanoramaViewer/PanoramaViewer.tsx';
import { PrivateRoutes } from '../possibly-stateful-components/ProtectedRoutes.tsx';
import { SavedSearchView } from '../views/saved-search/saved-search.tsx';
import { SavedSearchView as FavoritesPage } from '../views/favorites/favorites.tsx';
import { PortalHomeView } from '../views/portal-home-page/portal-home-page.tsx';
import { DocumentHubPage } from '../unstructured-pages/DocumentHubPage/DocumentHubPage.tsx';
import { ProjectStatusView } from '../views/project-status/project-status.tsx';
import { StyleBoard } from '../unstructured-pages/StyleBoard/StyleBoard.tsx';
import { MessageCenterPage } from '../unstructured-pages/MessageCenterPage/MessageCenterPage.tsx';
import {
  CustomerCenterPage,
} from '../unstructured-pages/CustomerCenterPage/CustomerCenterPage.tsx';
import { ContactInformationView } from '../views/contact-information/contact-information.tsx';
import { PricingDashboardView } from '../views/pricing-dashboard/pricing-dashboard.tsx';
import { Root } from '../layouts/root.tsx';
import { RootErrorBoundary } from '../views/error';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Root />,
    errorElement: <RootErrorBoundary />,
    children: [
      {
        path: '/',
        element: <HomePageView />,
      },
      {
        path: '/contact',
        element: <ScheduleMeetingView />,
      },
      {
        path: '/search/:query?',
        element: <SearchPage />,
      },
      {
        path: '/details/:id?',
        element: <DetailsPage />,
      },
      {
        path: '/models',
        element: <ModelsCatalog />,
      },
      {
        path: '/models/details/:id?',
        element: <ModelsDetailsView />,
      },
      {
        path: '/panorama',
        element: <PanoramaViewerPage />,
      },
      {
        element: <PrivateRoutes />,
        children: [
          {
            path: '/search/saved',
            element: <SavedSearchView />,
          },
          {
            path: '/search/favorites',
            element: <FavoritesPage />,
          },
          {
            path: '/portal',
            element: <PortalHomeView />,
          },
          {
            path: '/portal/document-hub',
            element: <DocumentHubPage />,
          },
          {
            path: '/portal/project-status',
            element: <ProjectStatusView />,
          },
          {
            path: '/portal/style',
            element: <StyleBoard />,
          },
          {
            path: '/portal/message-center',
            element: <MessageCenterPage />,
          },
          {
            path: '/models',
            element: <ModelsCatalog />,
          },
          {
            path: '/customer-center',
            element: <CustomerCenterPage />,
          },
          {
            path: '/contact-information',
            element: <ContactInformationView />,
          },
          {
            path: '/pricing',
            element: <PricingDashboardView />,
          },
        ],
      },
    ],
  },
];
